export const  config:IConfig.IConfigParams = {
    apiURL:"https://dayhanbank.gov.tm/kabulhana/online",
    cdnUrl: 'https://dayhanbank.gov.tm/kabulhana',
    get_footer_bottom_title: (allRightsReserved: string) => `${new Date().getFullYear()}ý. ${allRightsReserved}`,
    creditsURL:'https://dayhanbank.gov.tm/subcategory/6'
}